import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';

import Renderer from '../canvas/renderer'
import {changeCircleSize, changeLineSize, changeSquareSize} from "../canvas/shape";
import { adjustAfterFrameResize } from '../canvas/reposition-frame';
import util, {roundTwoDecimalsScaled} from "../util";
import Interactable from "../canvas/interactable";
import { DownOutlined } from '@ant-design/icons';
import constants from '../constants';

const SQUARE_CIRCLE = ['square', 'circle'];

export default @connect(reduce, actions)
class ResizeWidget extends Component {
  constructor(props) {
    super();

    this.initElement(props);

    this.updateShapeWidth = (ev) => {
      const type = this.props.shapeType;
      const value = ev.target.value;

      const unit = this.props.designUnit;
      const width = {};
      width[unit] = unit === 'in' ? value : value * Renderer.getDimensions().onePixelRatio;
      const height = {};
      height[unit] = unit === 'in' ? this.props.height : this.props.height * Renderer.getDimensions().onePixelRatio;

      if (SQUARE_CIRCLE.indexOf(type) > -1 && this.props.preserveRatio) {
        height[unit] = unit === 'in' ? value : value * Renderer.getDimensions().onePixelRatio;
        this.props.updateElementAttribute('height', value);
      }

      if (type === 'square') {
        changeSquareSize(this.props.isMultiSelect ? this.props.$elements : this.props.$element, width, height);
      } else if (type === 'circle') {
        changeCircleSize(this.props.isMultiSelect ? this.props.$elements : this.props.$element, width, height);
      } else if (type === 'line') {
        changeLineSize(this.props.isMultiSelect ? this.props.$elements : this.props.$element, width, height);
      }

      this.props.updateElementAttribute('width', value);
      this.props.$element.attr('data-px-width', value);
      this.props.$element.attr('data-px-height', this.props.height);
      this.throttledForceUpdate();
    };

    this.updateShapeHeight = (ev) => {
      const type = this.props.shapeType;
      const value = ev.target.value;

      const unit = this.props.designUnit;
      const width = {};
      width[unit] = unit === 'in' ? this.props.width : this.props.width * Renderer.getDimensions().onePixelRatio;
      const height = {};
      height[unit] = unit === 'in' ? ev.target.value : ev.target.value * Renderer.getDimensions().onePixelRatio;

      if (SQUARE_CIRCLE.indexOf(type) > -1 && this.props.preserveRatio) {
        width[unit] = unit === 'in' ? value : value * Renderer.getDimensions().onePixelRatio;
        this.props.updateElementAttribute('width', value);
      }

      if (this.props.shapeType === 'square') {
        changeSquareSize(this.props.isMultiSelect ? this.props.$elements : this.props.$element, width, height);
      } else if (this.props.shapeType === 'circle') {
        changeCircleSize(this.props.isMultiSelect ? this.props.$elements : this.props.$element, width, height);
      }

      this.props.updateElementAttribute('height', ev.target.value);
      this.props.$element.attr('data-px-width', this.props.width);
      this.props.$element.attr('data-px-height', ev.target.value);
      this.throttledForceUpdate();
    };

    this.updateWidth = (ev) => {
      const unit = this.props.designUnit;
      const cfg = {};
      cfg[unit] = ev.target.value;

      const ogWidth = this.props.$element.width();
      const ogHeight = this.props.$element.height();

      if (this.props.preserveRatio) {
        const height = Renderer.updateWidthAndHeightByWidth(this.props.isMultiSelect ? this.props.$elements : this.props.$element, cfg);
        this.props.updateElementAttribute('height', height);
        this.props.updateElementAttribute('width', ev.target.value);
        this.adjustAfterFrameResize(false, true, false, true, false, ogWidth, ogHeight);
      } else {
        Renderer.updateElementWidth(this.props.isMultiSelect ? this.props.$elements : this.props.$element, cfg);
        this.props.updateElementAttribute('width', ev.target.value);
        this.adjustAfterFrameResize(false, false, false, true, true, ogWidth, ogHeight);
      }
    };

    this.updateHeight = (ev) => {
      const unit = this.props.designUnit;
      const cfg = {};
      cfg[unit] = ev.target.value;

      const ogWidth = this.props.$element.width();
      const ogHeight = this.props.$element.height();

      if (this.props.preserveRatio) {
        const width = Renderer.updateWidthAndHeightByHeight(this.props.isMultiSelect ? this.props.$elements : this.props.$element, cfg);
        this.props.updateElementAttribute('width', width);
        this.props.updateElementAttribute('height', ev.target.value);
        this.adjustAfterFrameResize(false, true, false, true, false, ogWidth, ogHeight);
      } else {
        Renderer.updateElementHeight(this.props.isMultiSelect ? this.props.$elements : this.props.$element, cfg);
        this.props.updateElementAttribute('height', ev.target.value);
        this.adjustAfterFrameResize(false, true, false, false, true, ogWidth, ogHeight);
      }
    };

    this.adjustAfterFrameResize = (top, bottom, left, right, isSideReisze, ogWidth, ogHeight) => {
      if (this.props.$element.attr('data-component') === 'frame') {
        let edges = {top: top, bottom: bottom, left: left, right: right};
        adjustAfterFrameResize(edges, this.props.$element, this.props.$element.width(), this.props.$element.height(), this.props.$element.width()/this.props.$element.height(), isSideReisze, ogWidth, ogHeight);
      }
    }

    this.keyupWidth = (ev) => {
      ev.stopPropagation();
    };

    this.keyupHeight = (ev) => {
      ev.stopPropagation();
    };

    this.changeWidth = (ev) => {
      ev.stopPropagation();
      if (ev.data === ',' || ev.data === '.') return;

      let value = ev.target.value;
      if (value && !value.endsWith('.') && !value.endsWith(',')) {
        if (this.props.selectionType === 'shape') {
          this.updateShapeWidth(ev);
        } else {
          this.updateWidth(ev);
        }
      }
    };

    this.changeHeight = (ev) => {
      ev.stopPropagation();
      if (ev.data === ',' || ev.data === '.') return;

      let value = ev.target.value;
      if (value && !value.endsWith('.') && !value.endsWith(',')) {
        if (this.props.selectionType === 'shape') {
          this.updateShapeHeight(ev);
        } else {
          this.updateHeight(ev);
        }
      }
    };

    this.togglePreserveRatio = (ev) => {
      ev.stopPropagation();
      const val = !this.props.preserveRatio;
      Renderer.setPreserveRatio(this.props.$element, val);
      this.props.setPreserveRatio(val);
    };
  }

  initElement(props) {
    this.$element = props.$element;

    if (this.$element) {
      this.throttledForceUpdate = util.throttle(() => {
        const isInch = !props.designUnit || props.designUnit === 'in';

        this.state.width = isInch ? this.$element.attr('data-inch-width') : this.$element.attr('data-px-width');
        this.state.height = isInch ? this.$element.attr('data-inch-height') : this.$element.attr('data-px-height');

        this.forceUpdate();
      }, 50);

      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new window.MutationObserver(mutations => mutations.forEach(this.throttledForceUpdate.bind(this)))
      this.observer.observe(this.$element[0], {
        attributes: true,
        attributeFilter: ['style'],
      });
      util.nextTick(() => {
        this.throttledForceUpdate();
      });
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.initElement(nextProps);
  }

  render(props, state) {
    const scale = Interactable.getIfExists(props.$element)?.getScale() || 1;

    let width = state.width || props.width;
    width = roundTwoDecimalsScaled(width * scale);

    let height = state.height || props.height;
    height = roundTwoDecimalsScaled(height * scale);

    return (
      <div className="dropdown sizes">
        <a className={`dropdown-toggle ${!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'}`} data-hint="Size">
          <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-size"} /></svg>
          {props.isMobileVersion && <span>Size</span>}
        </a>
        <div className="dropdown-menu" style="width: auto; min-width: 260px;" data-close="no">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Size</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}
          <ul>
            <li className="shape-resize">
              <div>
                <label>Width</label>
                <div>
                  <input type="number" step=".25" value={width} onChange={this.changeWidth}/>
                  <span className="unit">{props.designUnit}</span>
                </div>
              </div>
              <div className={!!props.hideHeight ? 'hidden' : ''}>
                <label>Height</label>
                <div>
                  <input type="number" step=".25" value={height} onChange={this.changeHeight}/>
                  <span className="unit">{props.designUnit}</span>
                </div>
              </div>
              <div className={(!!props.isFrame || !!props.isImage || !!props.isShape || !!props.isIllustration) && !props.isLine ? '' : 'hidden'}>
                <label style={{lineHeight: '30px'}}>Preserve Ratio</label>
                <div className="checkbox">
                  <input type="checkbox" className="ios-toggle" checked={props.preserveRatio}/>
                  <label for="has-cash-in-store" className="checkbox-label sm" onClick={this.togglePreserveRatio}/>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
